import { CompleteTeacherClass } from 'entities/classes';

export const saveLastSelectedTeacherClassAs = (
  name: string,
  id: string,
): void => window.localStorage.setItem(name, id);

export const getLastSelectedTeacherClassByName = (
  name: string,
): string | null => window.localStorage.getItem(name);

export const getClassName = (teacherClass: CompleteTeacherClass) => {
  return teacherClass.gradesLabel
    ? `${teacherClass.displayName} - ${teacherClass.gradesLabel}`
    : teacherClass.displayName;
};
